// 🎨 POG LOGO ENGINE — nominative-fair-use brand identity for strip cards.
// Logos are each brand's OWN favicon, pulled from their own site (informational use only).
const BRAND_DOMAINS = {
  "dunkin": "dunkindonuts.com", "starbucks": "starbucks.com", "mcdonald": "mcdonalds.com",
  "burger king": "bk.com", "wendy": "wendys.com", "taco bell": "tacobell.com",
  "kfc": "kfc.com", "pizza hut": "pizzahut.com", "domino": "dominos.com",
  "subway": "subway.com", "chipotle": "chipotle.com", "chick fil a": "chick-fil-a.com",
  "popeyes": "popeyes.com", "panera": "panerabread.com", "five guys": "fiveguys.com",
  "jimmy john": "jimmyjohns.com", "jersey mike": "jerseymikes.com", "firehouse subs": "firehousesubs.com",
  "arby": "arbys.com", "sonic": "sonicdrivein.com", "dairy queen": "dairyqueen.com",
  "little caesars": "littlecaesars.com", "papa john": "papajohns.com", "tim hortons": "timhortons.com",
  "krispy kreme": "krispykreme.com", "baskin robbins": "baskinrobbins.com", "cold stone": "coldstonecreamery.com",
  "ihop": "ihop.com", "denny": "dennys.com", "applebee": "applebees.com",
  "olive garden": "olivegarden.com", "red lobster": "redlobster.com", "outback": "outback.com",
  "texas roadhouse": "texasroadhouse.com", "buffalo wild wings": "buffalowildwings.com",
  "cracker barrel": "crackerbarrel.com", "waffle house": "wafflehouse.com", "chili": "chilis.com",
  "red robin": "redrobin.com", "panda express": "pandaexpress.com", "wingstop": "wingstop.com",
  "raising cane": "raisingcanes.com", "culver": "culvers.com", "whataburger": "whataburger.com",
  "in n out": "in-n-out.com", "jack in the box": "jackinthebox.com", "white castle": "whitecastle.com",
  "walmart": "walmart.com", "costco": "costco.com", "target": "target.com",
  "walgreens": "walgreens.com", "cvs": "cvs.com", "rite aid": "riteaid.com",
  "home depot": "homedepot.com", "lowe": "lowes.com", "ace hardware": "acehardware.com",
  "menards": "menards.com", "harbor freight": "harborfreight.com", "tractor supply": "tractorsupply.com",
  "dollar general": "dollargeneral.com", "dollar tree": "dollartree.com", "family dollar": "familydollar.com",
  "five below": "fivebelow.com", "big lots": "biglots.com", "aldi": "aldi.us",
  "kroger": "kroger.com", "publix": "publix.com", "safeway": "safeway.com",
  "whole foods": "wholefoodsmarket.com", "trader joe": "traderjoes.com", "wegmans": "wegmans.com",
  "meijer": "meijer.com", "giant eagle": "gianteagle.com", "food lion": "foodlion.com",
  "piggly wiggly": "pigglywiggly.com", "winn dixie": "winndixie.com", "save a lot": "savealot.com",
  "best buy": "bestbuy.com", "gamestop": "gamestop.com", "staples": "staples.com",
  "office depot": "officedepot.com", "barnes noble": "barnesandnoble.com", "michaels": "michaels.com",
  "hobby lobby": "hobbylobby.com", "joann": "joann.com", "petco": "petco.com",
  "petsmart": "petsmart.com", "dick s sporting": "dickssportinggoods.com", "academy sports": "academy.com",
  "bass pro": "basspro.com", "cabela": "cabelas.com", "rei": "rei.com",
  "tj maxx": "tjmaxx.tjx.com", "marshalls": "marshalls.tjx.com", "ross": "rossstores.com",
  "burlington": "burlington.com", "kohl": "kohls.com", "macy": "macys.com",
  "nordstrom": "nordstrom.com", "old navy": "oldnavy.gap.com", "gap": "gap.com",
  "autozone": "autozone.com", "o reilly": "oreillyauto.com", "advance auto": "advanceautoparts.com",
  "napa auto": "napaonline.com", "pep boys": "pepboys.com", "jiffy lube": "jiffylube.com",
  "valvoline": "valvoline.com", "midas": "midas.com", "firestone": "firestonecompleteautocare.com",
  "discount tire": "discounttire.com", "carmax": "carmax.com",
  "sunoco": "sunoco.com", "shell": "shell.us", "bp": "bp.com", "exxon": "exxon.com",
  "mobil": "mobil.com", "chevron": "chevron.com", "citgo": "citgo.com", "valero": "valero.com",
  "marathon": "marathonbrand.com", "speedway": "speedway.com", "wawa": "wawa.com",
  "sheetz": "sheetz.com", "circle k": "circlek.com", "casey": "caseys.com",
  "quiktrip": "quiktrip.com", "racetrac": "racetrac.com", "7 eleven": "7-eleven.com",
  "pilot": "pilotflyingj.com", "love s": "loves.com", "gulf": "gulfoil.com",
  "t mobile": "t-mobile.com", "verizon": "verizon.com", "at t": "att.com",
  "cricket wireless": "cricketwireless.com", "metro by t": "metrobyt-mobile.com", "boost mobile": "boostmobile.com",
  "planet fitness": "planetfitness.com", "la fitness": "lafitness.com", "anytime fitness": "anytimefitness.com",
  "gold s gym": "goldsgym.com", "crunch fitness": "crunch.com", "ymca": "ymca.org",
  "great clips": "greatclips.com", "supercuts": "supercuts.com", "sport clips": "sportclips.com",
  "chase": "chase.com", "bank of america": "bankofamerica.com", "wells fargo": "wellsfargo.com",
  "pnc": "pnc.com", "td bank": "td.com", "fifth third": "53.com", "regions bank": "regions.com",
  "huntington": "huntington.com", "keybank": "key.com", "citizens bank": "citizensbank.com",
  "ups store": "theupsstore.com", "fedex": "fedex.com", "usps": "usps.com", "post office": "usps.com",
  "enterprise rent": "enterprise.com", "hertz": "hertz.com", "u haul": "uhaul.com",
  "goodwill": "goodwill.org", "salvation army": "salvationarmyusa.org",
  "hampton inn": "hilton.com", "holiday inn": "ihg.com", "marriott": "marriott.com",
  "best western": "bestwestern.com", "motel 6": "motel6.com", "super 8": "super8.com",
  "amc": "amctheatres.com", "regal": "regmovies.com", "cinemark": "cinemark.com",
  "dave buster": "daveandbusters.com", "chuck e cheese": "chuckecheese.com",
};
const KEYS = Object.keys(BRAND_DOMAINS).sort((a, b) => b.length - a.length);

const norm = (name) => ` ${(name || "").toLowerCase().replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim()} `;

export const brandDomain = (name) => {
  const n = norm(name);
  const hit = KEYS.find((k) => n.includes(` ${k} `) || n.startsWith(` ${k}`));
  return hit ? BRAND_DOMAINS[hit] : null;
};

const domainOf = (url) => {
  const m = /^(?:https?:\/\/)?(?:www\.)?([^/?#:]+)/.exec((url || "").trim().toLowerCase());
  return m ? m[1] : null;
};

export const faviconUrl = (domain, backendUrl) =>
  backendUrl ? `${backendUrl}/api/brand-logo/${domain}?v=3` : `https://www.google.com/s2/favicons?domain=${domain}&sz=128`;

// Resolution order: claimed upload → merchant's own link → brand directory → scouted source site
export const logoFor = (b, spot, backendUrl) => {
  if (b.logo_url) return `${backendUrl}${b.logo_url}`;
  const dom = domainOf(b.links?.web || b.links?.website) || brandDomain(b.name) || domainOf(spot?.offer?.source_url);
  return dom ? faviconUrl(dom, backendUrl) : null;
};

export const webUrlFor = (b, spot) => {
  const link = b.links?.web || b.links?.website;
  if (link) return link.startsWith("http") ? link : `https://${link}`;
  const dom = brandDomain(b.name);
  return dom ? `https://${dom}` : spot?.offer?.source_url || null;
};

// 🎯 DEEP DEAL LINKS — straight to each brand's deals/weekly-ad page (verified stable paths).
const BRAND_DEALS = {
  "dollargeneral.com": "deals", "walmart.com": "shop/deals", "target.com": "deals",
  "walgreens.com": "offers", "cvs.com": "weeklyad", "riteaid.com": "weekly-ad",
  "kroger.com": "savings", "publix.com": "savings", "safeway.com": "weeklyad",
  "meijer.com": "weekly-ad", "homedepot.com": "c/Savings", "lowes.com": "c/Savings",
  "staples.com": "deals", "petsmart.com": "sale", "hobbylobby.com": "weekly-ad",
  "macys.com": "shop/sale", "gamestop.com": "deals", "pizzahut.com": "deals",
  "tacobell.com": "deals", "bk.com": "offers", "wendys.com": "offers",
  "mcdonalds.com": "us/en-us/deals.html", "gianteagle.com": "savings",
};

// Merchant's own link always wins; brand deals page beats brand homepage.
export const dealUrlFor = (b, spot) => {
  const link = b.links?.web || b.links?.website;
  if (link) return link.startsWith("http") ? link : `https://${link}`;
  const dom = brandDomain(b.name);
  if (dom && BRAND_DEALS[dom]) return `https://${dom}/${BRAND_DEALS[dom]}`;
  return dom ? `https://${dom}` : spot?.offer?.source_url || null;
};
